// src/hooks/useNavigationLogger.js - ATUALIZAR (incluir cod_cli)
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useClient } from '../contexts/ClientContext'; // ✅ NOVO

const ROUTE_MENU_MAP = {
  '/dashboard': 'Dashboard de Casos',
  '/gestao-casos': 'Gestão de Casos',
  '/gestao-casos/novo': 'Novo Caso',
  '/gestao-casos/:id': 'Detalhe do Caso',
  '/gerar-documentos': 'Gerar Documentos',
  '/assistants': 'Assistentes OpenAI',
  '/chat-with-ai': 'Chat com a IA',
  '/clientdata': 'Dados do Cliente',
  '/usuarios': 'Gerenciar Usuários',
  '/consulta-codigo-penal': 'Análise de Caso',
  '/pesquisa-jurisprudencia': 'Pesquisa Jurisprudência',
  '/conferir-documento': 'Conferir Documento',
  '/estatisticas': 'Estatísticas de Uso'
};

const useNavigationLogger = () => {
  const location = useLocation();
  const { user } = useAuth();
  const { clienteAtual } = useClient(); // ✅ NOVO

  useEffect(() => {
    if (!user) {
      console.log('NavigationLogger: User not authenticated, skipping log');
      return;
    }

    const baseRoute = location.pathname.split('/').slice(0, 2).join('/') || location.pathname;
    const menuName = ROUTE_MENU_MAP[baseRoute] || baseRoute;

    if (baseRoute === '/login') {
      console.log('NavigationLogger: Login page, skipping log');
      return;
    }

    // The /sso location hash carries the session tokens: never send it to the access log
    if (baseRoute === '/sso') {
      return;
    }

    console.log('NavigationLogger: Preparing to log navigation', {
      baseRoute,
      menuName,
      fullPath: location.pathname,
      codCliente: clienteAtual.codCliente // ✅ NOVO
    });

    const logNavigation = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.log('NavigationLogger: No token found, skipping log');
          return;
        }

        const requestBody = {
          route: baseRoute,
          fullPath: location.pathname,
          menuName: menuName,
          search: location.search,
          hash: location.hash,
          cod_cli: clienteAtual.codCliente ? parseInt(clienteAtual.codCliente) : null // ✅ NOVO
        };

        console.log('NavigationLogger: Sending request', requestBody);

        const response = await fetch('/api/access-logs/navigation', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(requestBody)
        });

        if (!response.ok) {
          const errorText = await response.text();
          console.error('NavigationLogger: Request failed', {
            status: response.status,
            statusText: response.statusText,
            error: errorText
          });
        } else {
          console.log('NavigationLogger: Navigation logged successfully');
        }
      } catch (error) {
        console.error('NavigationLogger: Error logging navigation:', error);
      }
    };

    const timeoutId = setTimeout(logNavigation, 200);

    return () => clearTimeout(timeoutId);
  }, [location, user, clienteAtual.codCliente]); // ✅ NOVO: adicionar dependência
};

export default useNavigationLogger;